Pegasus.EmailPreferencesVisibilityToggleView = Em.View.extend({
  template: function() {
    var e = 'checked="checked"';
    if ( this.get("controller.isFooterEmailPreferencesEnabled") ) {
      e = "";
    }
    var t = [
      '<div class="visibility-toggle" draggable="false">',
      '<label class="switch-light switch-candy" onmouseup="$(window).trigger(\'didToggleEmailPreferencesDisplayMode\');" onclick="" draggable="false">',
      '<input type="checkbox" draggable="false" ' + e + " >",
      '<span class="toggle" draggable="false"><span draggable="false">'+Em.I18n.t('g.show')+'</span><span draggable="false">'+Em.I18n.t('g.hide')+'</span><a href="javascript:void(0);" draggable="false"></a></span>',
      "</label>",
      "</div>"
    ].join("");

    return Em.Handlebars.compile(t)
  }.property()
});
